import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import {
  USER_PERMISSION_SEARCH_COLUMNS,

} from "./consts";
import { UserPermissionSearchResultsProps } from "./types";

const UserPermissionSearchResults: React.FC<UserPermissionSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    selectableRows = false,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;


  return (
    <>
      <TableSearch
        columns={USER_PERMISSION_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows as unknown as number[]}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={selectableRows}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange as unknown as ((selected: number[] | number) => void) | undefined}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(UserPermissionSearchResults);
